import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { TemplateState } from '../../../types/common/types';
import { GzLoaderWebComponent } from '../../../ui/gzLoader';
import { GzImageRepoWebComponent } from '../../../ui/gzImageRepo';
import { ImageState } from '../../../ui/gzImageRepo/types';
import { FindingDetails } from '../../findingDetails/findingDetails';
import { UNAVAILABLE_DATA } from '../../types';

export class EasmFindingDetailsView extends BaseWebComponentView {
  getDomElements(): void {
    this.dom.$sectionsDiv = this.shadow.getElementById('sections');
    this.dom.$generalActions = this.shadow.getElementById('general-actions');
    this.dom.$panelTitle = this.shadow.getElementById('panelTitle');
  }

  setLoadingState() {
    this.resetTemplateState(this.dom.$sectionsDiv);
    this.setTemplateState(this.dom.$sectionsDiv, TemplateState.LOADING);
    this.clearDetailsPanelContent();

    const loadingTemplate = new GzLoaderWebComponent();
    loadingTemplate.rows = 15;
    loadingTemplate.columns = 2;

    this.dom.$sectionsDiv.appendChild(loadingTemplate);
  }

  removeLoadingState() {
    this.resetTemplateState(this.dom.$sectionsDiv);
  }

  buildSuccessView(data: any): void {
    this.resetTemplateState(this.dom.$sectionsDiv);
    this.clearDetailsPanelContent();
    this.setDetailsPanelTitle(data.name);
    const assetDetailsComponent = new FindingDetails();
    assetDetailsComponent.injectDependencies(this.dependencies);
    assetDetailsComponent.payload = data;
    this.dom.$sectionsDiv.appendChild(assetDetailsComponent);
  }

  buildErrorView() {
    this.resetTemplateState(this.dom.$sectionsDiv);
    this.setTemplateState(this.dom.$sectionsDiv, TemplateState.ERROR);
    this.setDetailsPanelTitle(UNAVAILABLE_DATA);
    this.clearDetailsPanelContent();
    this.buildErrorTemplate();
  }

  buildErrorTemplate() {
    const errorTemplate = new GzImageRepoWebComponent();
    errorTemplate.state = ImageState.ERROR;
    errorTemplate.innerHTML = `
          <gz-title fontSize='13'>${this.dependencies.translateFn(
            'Data loading has failed. Please try to refresh the page and if the issue persists contact Bitdefender Enterprise Support for more information.'
          )}
   </gz-title>
    `;

    this.dom.$sectionsDiv.appendChild(errorTemplate);
  }

  private clearDetailsPanelContent() {
    this.dom.$sectionsDiv.innerHTML = '';
  }

  private setDetailsPanelTitle(name: string) {
    this.dom.$panelTitle.innerText = name;
  }
}
